import React from 'react';
import { DialogTitle, DialogContent, DialogActions, DialogContentText, Button } from '@mui/material';
import { colors } from 'Constants/Colors';
import Modal from '../../Modal';

function ModalEdit({ title, question, cancelText, acceptText, cancel, accept, open, setOpen }) {
  const Content = (
    <div style={{ flexDirection: 'column' }}>
      <DialogTitle
        style={{
          fontWeight: 'bold',
          color: colors.BLACK,
          fontFamily: 'quicksand',
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ fontFamily: 'var(--app-font)' }}>{question}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button style={{ fontFamily: 'quicksand' }} color="success" variant="outlined" onClick={cancel}>
          {cancelText}
        </Button>
        <Button style={{ fontFamily: 'quicksand' }} color="success" variant="contained" onClick={accept}>
          {acceptText}
        </Button>
      </DialogActions>
    </div>
  );

  return (
    <div>
      <Modal open={open} setOpen={setOpen} Children={Content} />
    </div>
  );
}

export default ModalEdit;
